<template>
    <!--新增规范的页面-->
    <div>
        <el-dialog
                   :title="specifyTitle"
                   v-dialog-drag
                   :visible.sync="specifyCreate"
                   :append-to-body="true" :close-on-click-modal="false"
                   width="660px"
                   top="4vh"
                   :destroy-on-close="true" :show-close="false"
        >
            <!--ref="ruleForm" :rules="areaRules"-->
            <el-form :model="specifyInfo" size="small" ref="specifyForm" class="specifyForm">
                <!--<el-scrollbar style="height: 100%;">-->
                        <el-form-item
                                      label="序号"
                                      :label-width="formLabelWidth"
                        >
                            <el-input-number v-model="specifyInfo.sort" class="item" controls-position="right"  :min="1" ></el-input-number>
                        </el-form-item>
                        <el-form-item class="item"
                                      label="规范内容"
                                      :label-width="formLabelWidth"
                        >
                            <el-input class="item" type="textarea"
                                      v-model="specifyInfo.content"
                                      autocomplete="off"
                                      placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                <!--</el-scrollbar>-->
            </el-form>
            <span style="position: absolute;right: 30px;bottom: 13px;">
            <el-button class="editButton" size="small" @click="cancelAdd()">取消</el-button>
            <el-button type="primary" size="small" @click="entAdd('specifyForm')">确认</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
  import { editSpecification, saveSpecification } from "../../../api/module/checkSpecification";

  export default {
    name: "addSpecify",
    props:{
      specifyDialog:Boolean,
      currentMenuId: String,
      transferData:Object
    },
    data(){
      return {
        formLabelWidth: "100px",
        unCompleteMsg: this.global.unCompleteMsg,
        specifyCreate: this.specifyDialog,
        specifyTitle:'新建规范',
        specifyInfo:{
          sort:1,
          content:'',
          id:''
        },
        modifyFlag: false, //  新增或修改的标志
      }
    },
    methods:{
      cancelAdd(){
        this.specifyCreate = false
        this.$emit('closeAddSpecify',this.specifyCreate)
      },
      initData(){
        if(this.transferData.name === 'add'){
          this.modifyFlag = false
          this.specifyTitle = "新增规范"
          this.specifyInfo.sort = this.transferData.total + 1
        }else{
          this.modifyFlag = true
          this.specifyTitle = "修改规范"
          if(this.transferData.detail){
            let infos = this.transferData.detail
            this.specifyInfo.sort = infos.sort
            this.specifyInfo.content = infos.content
            this.specifyInfo.id = infos.id
          }

        }

      },
      // 确认修改
      entAdd(formName){
        this.$refs[formName].validate(valid => {
          if (valid) {
            let addObj = new FormData()
            addObj.append('sort',this.specifyInfo.sort)
            addObj.append('content',this.specifyInfo.content)

            if(!this.modifyFlag){
              saveSpecification(addObj,res=>{
              //console.log(res)
                this.$message({
                  type: "success",
                  message: '新建成功!',
                });
                this.cancelAdd()
                this.$emit('loadList') // 更新列表
              },error=>{
              //console.log(error)
              },this.currentMenuId)
            }else{
              addObj.append('id',this.specifyInfo.id)
              editSpecification(addObj,res=>{
              //console.log(res)
                this.$message({
                  type: "success",
                  message: '修改成功!',
                });
                this.cancelAdd()
                this.$emit('loadList') // 更新列表
              },error=>{
              //console.log(error)
              },this.currentMenuId)
            }
          } else {
            this.$message({
              showClose: true,
              message: this.unCompleteMsg,
              type: "error"
            });
            return false;
          }
        });
      }
    },
    mounted() {
      this.initData()
    }
  };
</script>

<style scoped>
    @import '../../../assets/dialog.css';
    @import '../../../assets/selfDefineDialog.css';
    /*//重置部分样式*/
    @import '../../../assets/reset.css';
    .specifyForm{
        height: 90%;width: 90%;margin-bottom: 40px;
    }
    .item{
        width: 100%;
    }
</style>
